import React from 'react';
import { useSelector } from 'react-redux';

import { PosPlugin } from '../../../plugin';
import { getExchangeState } from '../rdx';

const UIReturnTable: PosPlugin['UIReturnTable'] = ({ children }) => {
  const isExchange = useSelector(getExchangeState);
  if (isExchange.exchangeStep > 0) {
    const [ch] = React.Children.toArray(children);
    return React.cloneElement(ch as React.ReactElement<any>, {
      hideReturnReasons: true,
    });
  }
  return children;
};

export default UIReturnTable;
